import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Lock, Loader2, LogIn } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/constants/site";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      sessionStorage.setItem("bca_admin_token", data.token);
      navigate("/admin/leads");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="grid min-h-screen place-items-center px-6 pt-24">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        data-testid="admin-login-form"
        className="w-full max-w-md rounded-[2.5rem] border border-amber-200/50 bg-white p-9 shadow-[0_25px_60px_rgba(2,132,199,0.12)]"
      >
        <span className="grid h-14 w-14 place-items-center rounded-2xl bg-brand-sky/15 text-brand-deepsky">
          <Lock className="h-7 w-7" />
        </span>
        <h1 className="mt-5 font-display text-3xl font-semibold tracking-tight">Admin Login</h1>
        <p className="mt-1.5 text-sm text-slate-500">School office only — enter the admin password to view enquiries.</p>
        <Input
          type="password"
          required
          data-testid="admin-password-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Admin password"
          className="mt-7 rounded-2xl border-2 border-slate-200 bg-white px-4 py-3 h-auto text-base focus-visible:border-brand-sky"
        />
        <motion.button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          whileTap={{ scale: 0.97 }}
          className="mt-6 inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-full bg-brand-coral font-bold text-white shadow-[0_10px_30px_rgba(251,113,133,0.4)] transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60"
        >
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <LogIn className="h-4 w-4" />}
          {loading ? "Checking..." : "Login"}
        </motion.button>
      </motion.form>
    </main>
  );
}
